import { Link } from 'react-router-dom';
import { siteConfig } from '../config/siteConfig';

const HeroSection = () => (
    <div className='relative flex flex-col items-center justify-center min-h-screen px-6 pb-20 md:px-12 md:pb-0 md:pl-24 lg:pl-32 lg:pr-20 overflow-hidden'>
        <div className='relative z-10 max-w-6xl w-full'>
            <Title />
            <Description />
        </div>
        <Blob />
        <GridPattern />
    </div>
);

const Button = () => (
    <div className='pt-8'>
        <Link to={siteConfig.routes.projects}>
            <button className='group relative px-8 py-3.5 bg-emerald-600 hover:bg-emerald-700 rounded-xl font-semibold text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300'>
                <span className='relative z-10 flex items-center gap-2'>
                    View My Projects
                    <svg className='w-5 h-5 group-hover:translate-x-1 transition-transform' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 8l4 4m0 0l-4 4m4-4H3' />
                    </svg>
                </span>
            </button>
        </Link>
    </div>
);

const Title = () => (
    <div className='mb-8'>
        <h2 className='text-lg md:text-xl font-medium text-slate-400 mb-2 tracking-wide'>Hello, my name is</h2>
        <h1 className='text-5xl md:text-7xl lg:text-8xl font-black mb-4 leading-tight'>
            <span className='gradient-text font-grotesk'>{siteConfig.title}</span>
        </h1>
        <p className='text-xl md:text-2xl lg:text-3xl text-slate-300 font-light italic'>{siteConfig.tagline}</p>
    </div>
);

const Description = () => (
    <div className='max-w-2xl'>
        <p className='text-lg md:text-xl text-slate-300 leading-relaxed mb-2'>
            {siteConfig.description}
        </p>
        <div className='flex flex-wrap gap-3 mt-6 mb-4'>
            <span className='px-4 py-2 bg-slate-800/40 border border-slate-700/50 rounded-lg text-slate-300 text-sm font-medium backdrop-blur-sm'>
                Software Development
            </span>
            <span className='px-4 py-2 bg-slate-800/40 border border-slate-700/50 rounded-lg text-slate-300 text-sm font-medium backdrop-blur-sm'>
                System Administration
            </span>
            <span className='px-4 py-2 bg-slate-800/40 border border-slate-700/50 rounded-lg text-slate-300 text-sm font-medium backdrop-blur-sm'>
                Embedded Systems
            </span>
        </div>
        <Button />
    </div>
);

const Blob = () => (
    <div className='pointer-events-none absolute inset-0 overflow-hidden'>
        <div className='absolute top-1/4 -right-1/4 w-96 h-96 md:w-[600px] md:h-[600px]'>
            <div className='absolute rounded-full bg-emerald-500 w-full h-full filter blur-3xl opacity-20 animate-blob-one'></div>
        </div>
        <div className='absolute top-1/3 -right-1/4 w-96 h-96 md:w-[600px] md:h-[600px]'>
            <div className='absolute rounded-full bg-cyan-500 w-full h-full filter blur-3xl opacity-20 animate-blob-two'></div>
        </div>
        <div className='absolute top-1/2 -right-1/3 w-80 h-80 md:w-[500px] md:h-[500px]'>
            <div className='absolute rounded-full bg-blue-500 w-full h-full filter blur-3xl opacity-15 animate-blob-three'></div>
        </div>
    </div>
);

const GridPattern = () => (
    <div className='pointer-events-none absolute inset-0 opacity-[0.015]'>
        <div className='absolute inset-0' style={{
            backgroundImage: `linear-gradient(to right, rgb(148 163 184) 1px, transparent 1px),
                             linear-gradient(to bottom, rgb(148 163 184) 1px, transparent 1px)`,
            backgroundSize: '50px 50px'
        }}></div>
    </div>
);

export default HeroSection;
